import { render, staticRenderFns } from "./StatementsReports.vue?vue&type=template&id=22b2e509&"
import script from "./StatementsReports.vue?vue&type=script&lang=js&"
export * from "./StatementsReports.vue?vue&type=script&lang=js&"
import style0 from "./StatementsReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports